import { CognitoUserPool } from "amazon-cognito-identity-js";
import { CognitoClientId, CognitoUserPoolId } from "../constants";

let userPool;

export const getUserPool = () => {
    if (!userPool) {
        userPool = new CognitoUserPool({
            UserPoolId: CognitoUserPoolId,
            ClientId: CognitoClientId,
        });
    }

    return userPool;
};

export const getToken = () => {
    return new Promise((resolve, reject) => {
        const currentUser = getUserPool().getCurrentUser();
        if (currentUser) {
            currentUser.getSession((err, session) => {
                if (err) {
                    reject(err);
                    return;
                }

                resolve(session.getIdToken().getJwtToken());
            });
        } else {
            reject(new Error('No user is logged in'));
        }
    });
}
